<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template >
        <v-toolbar flat>  
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-filter</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-flex lg3>
              <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
            </v-flex>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }" >
                <v-btn outlined v-show=insertact  rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                  Add New Data
                  <v-icon class="ml-2">mdi-plus</v-icon>
                </v-btn>
              </template> 
              <v-card>
                <v-card-title>
                  <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                </v-card-title>
                <v-card-text style="height: 330px;" class="overflow-card">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <!-- <v-text-field 
                          prepend-inner-icon="mdi-account" 
                          outlined dense 
                          v-model="inputItem.name_social_media" 
                          label="Name Social Media">
                        </v-text-field> -->
                        
                        <v-select dense outlined :items="itemsmediasocial"  item-text="name_media" item-value="valuemedia"  v-model="name_social_media"  
                        hint="Name Social Media" persistent-hint></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-account" 
                          outlined dense 
                          v-model="inputItem.name_collection" 
                          label="Name Collection">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select dense outlined :items="itemsactivate"  item-text="name_active" item-value="valueactive"  v-model="statusactive"  
                        hint="Activate/Disable" persistent-hint></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-play" 
                          outlined dense 
                          v-model="inputItem.icon" 
                          label="Icon"
                          class="icon-input">
                          <template v-slot:append>
                            <v-btn icon small color="primary" @click="showIcon" class="mt-n1">
                              <v-icon>mdi-folder-open-outline</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>




                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" width="330px"> 
              <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                <v-avatar class="color-avatar3 my-4" size="62">
                  <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                </v-avatar>
                <div class="text-center text-h6 align-center justify-center font-weight-medium">
                  Confirm Deletion
                </div>
                <v-card-text class="align-center justify-center mt-2">
                  Are you sure you want to permanently delete this item?
                </v-card-text>
                <v-divider class="mt-4" style=""></v-divider>
                <v-card-actions class="align-center justify-center">
                  <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                    OK
                  </v-btn>
                  <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            
            <!-- dialog parm setting  -->
             
            <v-dialog v-model="dialogparmsetting" max-width="500px">
              <v-card>
                <v-card-title><span class="text-h6">Setting Variabel Parameter Collection</span></v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <!-- v for dinamis / -->
                      <v-row class="ma-0 pa-0 ml-3 mt-2" v-for="(item, index) in itemparmsettingcollection" :key="index">
                        <v-flex lg8>
                          <!-- <v-text-field outlined dense v-model="item.keywordname" label="Keywords"></v-text-field>/ -->
                          <v-select label="Variable Parameter" dense outlined 
                          :items="parameter" 
                          item-text="name_parameter" 
                          item-value="value_parameter"
                          v-model="item.parm_id" ></v-select> 
                        </v-flex>
                        <v-flex lg4>
                          <v-btn class="mx-2 elevation-0" @click="add_parm" dark outlined icon color="#0471A5"><v-icon>mdi-plus</v-icon></v-btn>
                          <v-btn class="elevation-0"  @click="remove_parm(item, index)" outlined color="#0471A5" icon><v-icon>mdi-minus</v-icon> </v-btn>
                        </v-flex>
                      </v-row>
                      <!-- end v for dinamis / -->
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeParmCollect">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="saveparamcollect">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="showiconclass" max-width="400px">
              <v-card>
                <v-card-title>
                  <span class="text-h6">Pilih Icon</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showiconclass = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text class="pt-0">
                  <div class="icon-grid">
                    <v-btn v-for="icon in iconOptions" :key="icon.value" @click="selectOption(icon.value)" class="icon-grid-item" icon small>
                      <v-icon>{{ icon.value }}</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>

        </v-toolbar>
      </template>
      <v-data-table 
      :headers="headers"
      :items="collection"
      :search="search"
      sort-by="paramid"
      class="ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >

        <!-- Correct slot usage for item.STATUS -->
        <template v-slot:item.STATUS="{ item }">
          <v-chip :color="getColor(item.STATUS)"  text-color="white" label small pill>
            {{ item.STATUS }}
          </v-chip>
        </template>

        <template v-slot:[`item.icon`]="{ item }">
          <v-icon >{{ item.ICON }} </v-icon>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-show=updateact  small class="mr-2" @click="editItem(item.ID)">
            mdi-pencil
          </v-icon>
          <v-icon v-show=deleteact  @click="deleteItem(item.ID)" small>
            mdi-delete
          </v-icon>
          
        
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.css';
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",

      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      dialog: false,
      dialogDelete: false,
      showiconclass: false,
      
      dialogparmsetting: false,
      itemparmsettingcollection: [
        {parm_id : '',parm : '',collection_id : ''}
      ],
      
      parameter: [
            {
              value_parameter: '', 
              name_parameter: '' 
            }
      ],
      
      search:'',
      headers: [
        { text: 'Name Social Media', value: 'NAME_SOCIAL_MEDIA' },
        { text: 'Collection', value: 'NAME_COLLECTION' },
        { text: 'Status', value: 'STATUS' },
        { text: 'Icon', value: 'ICON' },
        { text: 'Image', value: 'icon', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ], 
       
      collection: [],
      id_collection:'',
      collection_id_edit:'',
      
      statusactive: 1,
      itemsactivate: [//choice select
        {valueactive: 1, name_active: "Enabled" },
        {valueactive: 0, name_active: "Disabled" }
      ],
      itemsmediasocial: [//choice select
        {valuemedia: 'News', name_media: "News" },
        {valuemedia: "Twitter", name_media: "Twitter" },
        {valuemedia: "Youtube", name_media: "Youtube" },
        {valuemedia: "Instagram", name_media: "Instagram" },
        {valuemedia: "Tik Tok", name_media: "Tik Tok" },
        {valuemedia: "Facebook", name_media: "Facebook" },
        {valuemedia: "Threads", name_media: "Threads" },
      ],
      name_social_media:'News',
      
      iconOptions: [
        { value: 'mdi-home' },
        { value: 'mdi-chart-line' },
        { value: 'mdi-chart-bar' },
        { value: 'mdi-google-analytics' },
        { value: 'mdi-cloud' },
        { value: 'mdi-camera-metering-center' },
        { value: 'mdi-camera-metering-matrix' },
        { value: 'mdi-server' },
        { value: 'mdi-format-list-bulleted' },
        { value: 'mdi-cog-outline' },
        { value: 'mdi-cogs' },
        { value: 'mdi-twitter' },
        { value: 'mdi-youtube' },
        { value: 'mdi-web' },
        { value: 'mdi-instagram' },
        { value: 'fa-brands fa-threads' },
        { value: 'fa-brands fa-tiktok' },
        { value: 'mdi-facebook' },
        { value: 'mdi-facebook-messenger' },
        { value: 'mdi-google' },
        { value: 'mdi-skype' },
        { value: 'mdi-email' },
        { value: 'mdi-forum-outline' },
        { value: 'mdi-animation' },
        { value: 'mdi-animation-outline' },
        { value: 'mdi-animation-play' },
        { value: 'mdi-animation-play-outline' },
        { value: 'mdi-signal-variant' },
        { value: 'mdi-antenna' },
        { value: 'mdi-access-point' },
        { value: 'mdi-api' },
        { value: 'mdi-api-off' },
        { value: 'mdi-fire' },
        { value: 'mdi-cube' },
        { value: 'mdi-cube-off' },
        { value: 'mdi-cube-outline' },
        { value: 'mdi-cube-off-outline' },
        { value: 'mdi-cube-scan' },
        { value: 'mdi-cube-send' },
        { value: 'mdi-laptop' },
        { value: 'mdi-puzzle-outline' },
        { value: 'mdi-account' },
        { value: 'mdi-account-multiple' },
        { value: 'mdi-account-group' },
        { value: 'mdi-account-details-outline' },
        { value: 'mdi-table' },
        { value: 'mdi-pin' },
        { value: 'mdi-content-copy' },
        { value: 'mdi-keyboard-variant' },
        { value: 'mdi-arrow-decision' },
      ],
      editedIndex: -1,
      inputItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Collection' : 'Update Collection'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      getColor(status) {
        return status === 'Disabled' ? 'red' : 'green';
      },
      showIcon() {
        if(this.showiconclass  == false){
          this.showiconclass  = true
        }else{
          this.showiconclass  = false
        }
      },
      selectOption(value) {
        this.inputItem.icon  = value;
        this.showiconclass  = false

      },
      initialize () {
        this.tableLoading = true;
        axios.get("collection",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            // this.collection = response.data;
            // this.collection = decryptionData(response.data.token);
            
          const data_dec = decryptionData(response.data.token);
          this.collection = data_dec.data_collection;

          
            let result_prm = '';
            let arr_data_parm = [];
            if(data_dec.variableparm.length > 0){
              for (let i = 0; i <  data_dec.variableparm.length; i++) {  
                  result_prm = {
                    name_parameter : data_dec.variableparm[i].PARAM_ID,
                    value_parameter : data_dec.variableparm[i].PARAM_ID
                  };
                  arr_data_parm.push(result_prm);
              }
              // console.log(arr_data);
              this.parameter = arr_data_parm;
            }


        this.collection = data_dec.data_collection;
            // auth action  
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }   
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
                  case 404:
                        // this.$refs.alert.error_login(404);
                      break;
                  case 403:
                        // this.$refs.alert.error_login(403);
                      break;
                  default:
                      console.log('some other error');  // end up here all the time
                      break;
              }
          this.errors=e.response.data.msg;
        });
        
      },
      deleteItem (item) {
        
        this.id_collection = item
        this.editedIndex = this.collection.indexOf(item)
        this.inputItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.collection.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "/collection/delete",
          data: {
            id: this.id_collection
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          this.initialize();
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeDelete()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.closeDelete()
              } 
        })
        .catch(function (error) {
          console.log(error);
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed';
          this.btnload = false
          this.closeDelete()
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.editedIndex = 1
        this.inputItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "/collectionId",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            const dat  = decryptionData(response.data.token);

            this.id_collection = dat.ID;
            this.collection_id_edit = dat.ID;
            this.statusactive = dat.STATUS;
            this.name_social_media = dat.NAME_SOCIAL_MEDIA;
            
            this.inputItem = {
              id:dat.ID,
              name_collection:dat.NAME_COLLECTION,
              icon:dat.ICON
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          console.log(error);
        })
      },
      save () {
        
        this.btnload = true
        if (this.editedIndex > -1) {
          axios.put("/collection/update", 
            {
              id:this.inputItem.id,
              collection_id_edit:this.collection_id_edit,
              name_social_media:this.name_social_media,
              name_collection:this.inputItem.name_collection,
              icon:this.inputItem.icon,
              status:this.statusactive,
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            this.initialize();
              this.$router.push('/collection');
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            this.alertFailed = true;
                            this.alert_err_attention =  e.response.msg;
                            this.btnload = false
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                }
            this.errors=e.response.data.msg;
          });
          Object.assign(this.collection[this.editedIndex], this.inputItem)

        } else {
          axios.post("/collection/insert", 
            {
              name_social_media:this.name_social_media,
              name_collection:this.inputItem.name_collection,
              icon:this.inputItem.icon,
              status:this.statusactive,
              
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            this.initialize();
              this.$router.push('/collection');
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                  case 400:
                        this.alertFailed = true;
                        this.alert_err_attention =  e.response.data.msg;
                        this.btnload = false
                      break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
            this.errors=e.response.data.msg;
          });
          
        }
      },
      close () {
        this.showiconclass  = false
        this.dialog = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      parameterSetting (item){
        // alert(item);
        
        this.id_collection = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-collection-parm",
          data: {
            id_collection : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            const dat = decryptionData(response.data.token);
            // ----- selected role privilage ----
            let result = '';
            let arr_data = [];
            if(dat.length > 0){
              for (let i = 0; i <  dat.length; i++) { 
                this.add_parm(); 
                  result = {
                    parm_id : dat[i].PARAM_ID,
                    parm : dat[i].PARAM,
                    collection_id : dat[i].COLLECTION_ID,
                  };
                  arr_data.push(result);
              }
              // this.dialogparmsetting= arr_data;
            }else{
                  result = {
                    parm_id : '',
                    parm : '',
                    collection_id : ''
                  };
                  arr_data.push(result);

            }
            this.itemparmsettingcollection= arr_data;
            // ----- end selected role privilage ----
            // id_keyword
            this.dialogparmsetting =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },
      
      add_parm() {
        this.originalData = null
        this.itemparmsettingcollection.push({ parm_id: '' ,parm : '',collection_id : ''})
        // this.editIndex = this.item_insert_dinamis.length - 1
      },
      
      remove_parm(item, index) {
        // console.log(item.id_privilage);
        // console.log('auu'+index);
       
        if(index > 0){
          //   if(item.id_privilage != null){
          //   axios({
          //     method: "delete",
          //     url: "/delete-group-privilage-topic",
          //     data: {
          //       seq_id_privilage: item.id_privilage
          //     },
          //     headers:{'auth-token':localStorage.getItem('token_app')},
          //     dataType: 'json'
          //   })
          //   .then((response) => {
          //     // handle success
          //     this.editItemPrivilage(item.id_topic_keyword);
          //     console.log(response);
          //     this.initialize();
          //   })
          //   .catch(function (error) {
          //     // handle error
          //     console.log(error);
          //   })
          // }
          this.itemparmsettingcollection.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },
      closeParmCollect(){
        this.dialogparmsetting = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      saveparamcollect(){
        
        axios.put("/action-collection-group-parm", 
            {
              id_collection:this.id_collection,
              par_parm:this.itemparmsettingcollection
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {  
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/Collection');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeParmCollect()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          // this.closeParmCollect();
      },
    },
  }
</script> 

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(44px, 1fr));
  gap: 4px;
  max-height: 300px;
  overflow-y: auto;
}
.icon-grid-item {
  width: 44px !important;
  height: 44px !important;
}
</style>
